import { DeleteOutlined } from '@ant-design/icons';
import AudiencesModel from '@mm/state/model/AudiencesModel';
import ConnectionModel from '@mm/state/model/ConnectionModel';
import TagModel from '@mm/state/model/TagModel';
import { AudienceSimpleSelect } from '@mm/stateful-components';
import { Switch } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { TagsSelector } from '../TagsSelector/TagsSelector';
import styles from './ShopifyIntegrations.module.css';

type Props = {
  className?: string;
  connection: Partial<ConnectionModel>;
  canDelete?: boolean;
  audiences: AudiencesModel[];
  activeFbPageId: number;
  availableTags: TagModel[];
  onlyTags?: boolean;
  update: (params: Partial<ConnectionModel>) => void;
  remove: () => void;
};

export const ShopifyConnection = ({
  className,
  connection,
  update,
  remove,
  canDelete,
  audiences,
  activeFbPageId,
  availableTags,
  onlyTags,
}: Props) => (
  <div className={className}>
    {!onlyTags && (
      <div className={styles.gridColumn}>
        <AudienceSimpleSelect
          options={audiences}
          className={styles.audiencesSelect}
          selectedAudienceId={connection?.audienceId || undefined}
          onChange={audienceId => update({ audienceId })}
        />
      </div>
    )}

    <div className={styles.gridColumn}>
      <TagsSelector
        onChange={tag => {
          if (tag) {
            update({
              tags: [
                ...(connection?.tags || []),
                { name: tag.name, sentAs: tag.name },
              ],
            });
          }
        }}
        onTagRemove={tag => {
          if (tag) {
            const tagIndex = (connection?.tags || []).findIndex(
              connTag => connTag.name === tag.name,
            );
            if (tagIndex >= 0) {
              update({
                tags: [
                  ...(connection?.tags || []).slice(0, tagIndex),
                  ...(connection?.tags || []).slice(tagIndex + 1),
                ],
              });
            }
          }
        }}
        fbPageId={activeFbPageId}
        availableTags={availableTags}
        tags={(connection?.tags || []).map(tag => ({
          name: tag.name,
          unsaved: false,
          kind: 'regular',
        }))}
      />
    </div>
    {!onlyTags && (
      <div className={classNames(styles.gridColumn, styles.actionsColumn)}>
        <Switch
          defaultChecked={connection?.active}
          checkedChildren="Sync"
          unCheckedChildren="Sync"
          className={styles.switch}
          onChange={ok => update({ active: ok })}
          disabled={!connection?.audienceId}
        />
        {canDelete && <DeleteOutlined onClick={() => remove()} />}
      </div>
    )}
  </div>
);
